(function($, moment) {
	"use strict";

	/**
	 * Ce plugin crée un popin permettant de définir les champs à modifier dans la grille appelante :
	 *
	 * @param {Array(name, title} fields - la liste des champs de mise à jour de masse disponible
	 * @param {Function(entries)} callback - la méthode appelée en cas de changement validés par l'utilisateur
	 */
	$.fn.materialPopinMassupdates = function(title, langCode, fields, callback) {
		// Récupération de la langue
		var lang = $.fn.materialPopinMassupdates.langs[langCode];

		// Création du template
		var div = $(this);
		div.append(''
				+ '<div>'
				+ '  <div class="dropdown">'
				+ '    <button class="btn btn-link dropdown-toggle" type="button" data-toggle="dropdown">'
				+ '      ' + lang['AddButton'] + ' <span class="caret"></span>'
				+ '    </button>'
				+ '    <ul class="dropdown-menu"></ul>'
				+ '  </div>'
				+ '</div>'
				+ '<table style="width: 100%; max-width: 100%; margin-top: 20px; table-layout: fixed; ">'
				+ '  <thead>'
				+ '    <tr>'
				+ '      <th style="width: 24px; ">&nbsp;</th>'
				+ '      <th style="width: auto; ">' + lang['FieldColumn'] + '</th>'
				+ '      <th style="width: 50px; ">' + lang['ClearColumn'] + '</th>'
				+ '      <th style="width: auto; ">' + lang['ValueColumn'] + '</th>'
				+ '    </tr>'
				+ '  </thead>'
				+ '  <tbody>'
				+ '  </tbody>'
				+ '  <tfoot style="display: none;">'
				+ '    <tr>'
				+ '      <td class="delete"><a href="#" class="material-icons" title="">delete</a></td>'
				+ '      <td class="field"></td>'
				+ '      <td class="clear" style="text-align: center; "><input type="checkbox" /></td>'
				+ '      <td class="value"></td>'
				+ '    </tr>'
				+ '  </tfoot>'
				+ '</table>'
				+ '');

		// Remplir le menu déroulant avec les champs disponibles
		div.find('.dropdown').children('ul').append(fields.map(function(field) {
			var a = $('<a href="#" />').text(field.title).attr('data-name', field.name);
			return $('<li />').append(a).get(0);
		}));

		// Ecouter la sélection dans le menu déroulant pour ajouter une ligne dans le tableau
		div.find('.dropdown').on('click', 'a', function(event) {
			// Eviter le # dans l'URL
			event.preventDefault();
			// Ajouter une ligne dans le tableau
			var target = $(event.target);
			addEntry({ field: target.attr('data-name') });
			// Masquer la sélection dans le menu déroulant
			target.closest('li').css('display', 'none');
			if (! table.is(':visible'))
				// Afficher le tableau si au moins un critère
				table.show();
		});

		// Récupérer le tableau contenant les champs choisis par l'utilisateur
		var table = div.children('table');
		table.hide();
		// Ecouter le clic sur la case à cocher pour activer ou désactiver la zone de saisie de valeur
		table.on('change', '.clear input', function() {
			$(this).closest('tr').children('td.value').css('visibility', $(this).is(':checked') ? 'hidden' : 'visible');
		});

		// Ecouter le clic sur les boutons de suppression
		table.on('click', '.delete > a', function(event) {
			// Eviter le # dans l'URL
			event.preventDefault();
			// Supprimer la ligne
			var tr = $(this).closest('tr');
			tr.remove();
			// Réactiver la sélection dans le menu déroulant
			div.find('li').each(function() {
				if ($(this).find('a').attr('data-name') === tr.attr('data-name'))
					$(this).css('display', 'inline'); 
			});
			// Afficher / cacher en fonction du nombre de lignes restantes
			table.toggle(table.find('>tbody>tr').length >= 1);
		});

		function addEntry(entry) {
			var field = fields.filter(function(f) { return f.name === entry.field; })[0];
			// Création de la ligne en clonant le template
			var tr = table.find('>tfoot>tr').clone()
				.attr('data-name', entry.field)
				.appendTo(table.children('tbody'));
			// Nom de champ pour la ligne
			tr.children('.field').text(field.title);
			// la checkbox en MD
			tr.find('> .clear > input').materialCheckbox({});
			// Zone de saisie de valeur, on fonction du type de champ
			field.appendEditor(tr.children('.value'), entry.value, langCode);
			return tr;
		}

		// Affichage du popin une fois que tout est prêt
		div.materialPopin({
			title: title,
			closeButtonTitle: lang['CancelButton'],
			buttons : [{
				icon : 'done',
				visible : true,
				title: lang['ValidateButton'],
				onclick : function validate() {
					// On récupère les champs a mettre à jour, un tableau { field, value }
					var entries = [];
					div.find('>table>tbody>tr').each(function() {
						// Parcourir chaque ligne du tableau
						var tr = $(this);
						// Récupérer le champ, pour son nom et la manière d'obtenir la valeur
						var field = fields.filter(function(f) { return f.name === tr.attr('data-name'); })[0];
						// Récupérer la valeur de l'option "Vider"
						var clear = tr.children('.clear').find('input').is(':checked');
						// Récupérer la valeur TYPEE, par exemple un entier, un booléen, une String, un tableau d'id, ...
						// si l'option "vider" est inactive
						var value = ! clear ? field.getEditorValue(tr.children('.value')) : '';
						// Ajouter l'entrée correspondant à la ligne
						entries.push({ field: field.name, clear: clear, value: value });
					});
					// Une fois récupérées les données, appeler la callback avec les champs sélectionnés pour la mise à jour massive, validés par l'utilisateur
					callback(entries);
					// Enfin, fermer le popin
					div.materialPopin('close');
				}
			}]
		});
	};

	/**
	 * Constructeur pour définir un champ de mise à jour multiple disponible
	 *
	 * @param {String} name - le nom interne du champ
	 * @param {String} title - l'intitulé du champ
	 * @return {MaterialPopinMassupdateField} un nouveau champ de mise à jour multiple, incomplet le temps qu'une méthode asXXX n'a pas été appelée
	 */
	function MaterialPopinMassupdateField(name, title) {
		// Le nom du champ disponible (les filtres actifs utilisent le nom pour indiquer le filtre associé)
		this.name = name;
		// L'intitulé du filtre, qui apparait dans le combo d'ajout puis dans une colonne de la table
		this.title = title;
	}

	/**
	 * Cette méthode doit être dérivée pour chaque type de champ pour indiquer comment créer un éditeur pour la colonne "Valeur"
	 * 
	 * @param {jQuery} parent - l'élément DOM dans lequel ajouter l'éditeur
	 * @param {*} value - la valeur typé de l'entrée pour ce champ
	 * @param {String} langCode - la langue fr/en/de utilisée
	 */
	MaterialPopinMassupdateField.prototype.appendEditor = function(parent, value, langCode) {
		throw new Error('Implémentation manquante');
	};

	/**
	 * Cette méthode doit être dérivée pour chaque type de champ pour indiquer comment récupéer une valeur dans l'éditeur
	 * 
	 * @param {jQuery} parent - l'élément DOM dans lequel l'éditeur a été ajouté
	 */
	MaterialPopinMassupdateField.prototype.getEditorValue = function(parent) {
		throw new Error('Implémentation manquante');
	};

	/**
	 * Cette méthode finalise un filtre numérique, qui manipule des Number
	 *
	 * @param {Boolean} isInteger - indique si le champ est un entier (true) ou un flottant (false)
	 */
	MaterialPopinMassupdateField.prototype.asNumber = function(isInteger) {
		// L'éditeur est un "input[type=text]"
		this.appendEditor = function(parent, value, langCode) {
			$('<input class="form-control" type="text" />').val((value || '').toString()).appendTo(parent);
		};
		// Mais la valeur est renvoyée comme un entier ou un flottant, en fonction de "isInteger"
		this.getEditorValue = function(parent) {
			var s = parent.children('input').val();
			return isInteger ? parseInt(s) : parseFloat(s);
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ booléen, qui manipule des Boolean
	 *
	 * @param {String} trueText - indique le texte affiché pour dire "true", par exemple 'Oui' ou 'Actif'
	 * @param {String} falseText - indique le texte affiché pour dire "false", par exemple 'Non' ou 'Inactif'
	 */
	MaterialPopinMassupdateField.prototype.asBoolean = function(trueText, falseText) {
		// Pour les booléens, on choisi la valeur oui/non via un select dont un peut personnalisé le texte 
		this.appendEditor = function(parent, value, langCode) {
			$('<select class="form-control" style="padding-right: 16px;" />')
				.append($('<option value="true" />').text(trueText).prop('selected', value !== false))
				.append($('<option value="false" />').text(falseText).prop('selected', value === false))
				.appendTo(parent); 
		};
		// Mais la valeur saisie est renvoyée comme un booléen
		this.getEditorValue = function(parent) {
			return parent.children('select').val() === 'true';
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ texte, qui manipule des String
	 */
	MaterialPopinMassupdateField.prototype.asString = function() {
		// Par contre, l'éditeur est un input[type=text] tout simple
		this.appendEditor = function(parent, value, langCode) {
			$('<input class="form-control" type="text" />').val(value || '').appendTo(parent);
		};
		// Et la valeur saisie simplement renvoyée en texte
		this.getEditorValue = function(parent) {
			return parent.children('input').val();
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ date, qui manipule des "long" représentant des dates
	 *
	 * @param {String} format - indique le format utilisé pour afficher les dates
	 */
	MaterialPopinMassupdateField.prototype.asDate = function(format) {
		// On délègue à asDatetime, en indiquant que l'on veut les dates mais pas les heures
		return this.asDatetime(format, true, false);
	};

	/**
	 * Cette méthode finalise un champ heure, qui manipule des "long" représentant des heures
	 *
	 * @param {String} format - indique le format utilisé pour afficher les heures
	 */
	MaterialPopinMassupdateField.prototype.asTime = function(format) {
		// On délègue à asDatetime, en indiquant que l'on veut les heures mais pas les dates
		return this.asDatetime(format, false, true);
	};

	/**
	 * Cette méthode finalise un champ date+heure, qui manipule des "long" représentant des dates et/ou des heures
	 *
	 * @param {String} format - indique le format utilisé pour afficher les valeurs
	 * @param {Boolean} pickDate - si false, désactive la saisie des dates (et crée donc un composant pour les heures)
	 * @param {Boolean} pickTime - si false, désactive la saisie des heures (et crée donc un composant pour les dates)
	 */
	MaterialPopinMassupdateField.prototype.asDatetime = function(format, pickDate, pickTime) {
		// Pour permettre d'appeler "new field(...).asDatetime('YYYY/MM/DD HH:mm'), les paramètres absents sont considérés "true"
		pickDate = (pickDate !== false); // true ou undefined
		pickTime = (pickTime !== false); // true ou undefined
		// L'éditeur est un input[type=text] avec un placeholder auquel on applique si disponible le composant "Bootstrap Datetimepicker"
		this.appendEditor = function(parent, value, langCode) {
			// Formattage de value (un "long") en texte pour l'utilisateur  
			var text = value ? moment(value).format(format) : '';
			// Ajout de l'input avec valeur dans le parent
			var input = $('<input class="form-control" type="text" />').attr('placeholder', format).val(text).appendTo(parent);
			// Si le composant "Bootstrap Datetimepicker" est dispo, on l'utilise car plus joli qu'un <input type="text" />
			if (!! $.fn.datetimepicker) {
				// il faut dans ce cas que le (grand-)parent ait une position "relative"
				input.wrap('<div style="position: relative;" />').datetimepicker({
					locale: langCode,
					format: format,
					useCurrent: false,
					calendarWeeks: true
				});
			}
		};
		// La valeur saisie est renvoyée comme un "long", en prenant soin de vider la partie date ou heure si besoin
		this.getEditorValue = function(parent) {
			var text = parent.find('input.form-control').val();
			if (!text)
				return undefined;
			var value = moment(text, format);
			if (!pickDate)
				value = value.year(1970).month(0).date(1);
			if (!pickTime)
				value = value.startOf('day');
			return value.toDate().getTime();
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ liste, qui permet de sélectionner un id (mono sélection) ou un tableau d'id (sélection multiple) 
	 *
	 * @param {Array} options - la liste des options sélectionnables avec "id" (entier) et "title" (texte)
	 * @param {boolean} isMulti - mutilple (true) ou mono (false) sélection
	 * @param {Object} multiselectOptions - pour personnaliser le composant "Bootstrap Multiselect", si trouvé et utilisé
	 */
	MaterialPopinMassupdateField.prototype.asList = function(options, isMulti, multiselectOptions) {
		// L'éditeur est un composant "select" auquel on applique si disponible le composant "Bootstrap Multiselect"
		this.appendEditor = function(parent, value, langCode) {
			// Création du <select />
			var select = $('<select class="form-control" style="padding-right: 16px;" />');
			if (isMulti)
				select.attr('multiple', 'multiple');
			// Ajout des options
			select.append(options.map(function(o) {
				return $('<option />').attr('value', o.id).text(o.title).prop('selected', value && (value.indexOf(o.id) >= 0)).get(0);
			}));
			// Ajout du select au parent donné
			select.appendTo(parent);
			// Si le composant "Bootstrap Multiselect" est dispo, on l'utilise car plus joli qu'un <select multiple />
			if (!! $.fn.multiselect) {
				select.multiselect($.extend({
					buttonWidth: '100%',
					dropRight: true,
					maxHeight: 200,
					nonSelectedText: '...',
					numberDisplayed: Number.MAX_VALUE
				}, multiselectOptions));
			}
		};
		// La valeur saisie est renvoyée comme entier (mono sélection) ou un tableau d'entier (sélection multiple)
		this.getEditorValue = function(parent) {
			
			if (isMulti)
				return (parent.find('select').val() || []).map(function(s) { return parseInt(s); });
						
			return parseInt(parent.find('select').val());
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ arborescence, qui permet de sélectionner un tableau d'id
	 *
	 * @param {Array} options - la liste des options sélectionnables avec "id" (entier), "title" (texte) et éventuellement "children" (récursivité)
	 * @param {Object} multiselectOptions - pour personnaliser le composant "Bootstrap Multiselect", si trouvé et utilisé
	 */
	MaterialPopinMassupdateField.prototype.asTree = function(options, noDepth, multiselectOptions) {
		// L'éditeur est un composant "select" auquel on applique si disponible le composant "Bootstrap Multiselect"
		this.appendEditor = function(parent, value, langCode) {
			// Création du <select />
			var select = $('<select class="form-control" style="padding-right: 16px;" />');
			// Ajout des options RECURSIVEMENT
			function append(list, textPrefix, pathPrefix, parentIds, depth) {
				list.forEach(function(o) {
					$('<option />').prop('selected', value && (value.indexOf(o.id) >= 0))
						.attr('value', o.id.toString())
						.attr('data-path', pathPrefix + o.title)
						.attr('ids', parentIds + o.id)
						.text(textPrefix + o.title)
						.appendTo(select);
					if (o.children && o.children.length)
						append(o.children, textPrefix + '\u00A0\u00A0', pathPrefix + o.title + ' > ', parentIds + o.id + ',', depth + 1);
				});
			}
			
			// Fonction qui affiche le chemin complet des éléments sélectionnés
			function buttonString(options) {
				if (!options || options.length === 0)
					return '...';
				return options.filter(':selected').attr('data-path');
			}

			append(options, '', '', '', 0);
			// Ajout du select au parent donné
			select.appendTo(parent);
			// Si le composant "Bootstrap Multiselect" est dispo, on l'utilise car plus joli qu'un <select multiple />
			if (!! $.fn.multiselect) {
				// Activation du composant
				select.multiselect($.extend({
					buttonText: buttonString,
					buttonTitle: buttonString,
					buttonWidth: '100%',
					dropRight: true,
					maxHeight: 200
				}, multiselectOptions));
			}
		};
		// La valeur retournée est un tableau contenant les identifiants des éléments de la hiérarchie sélectionnée.
		this.getEditorValue = function(parent) {
			if (noDepth) // on veut juste une valeur
				return parseInt(parent.find('select').val());
			// on veut la hiérarchie complète
			return parent.find('select').children('option:selected').attr('ids').split(',').map(function(o) { 
				return parseInt(o); 
			});
		};
		return this;
	};

	/** Exposer la méthode "MaterialPopinMassupdateField" à l'extérieur via "$.fn.materialPopinMassupdates.Field" */
	$.fn.materialPopinMassupdates.Field = MaterialPopinMassupdateField;

	/** Traduction des libellés utilisés dans les différentes langues supportées */
	$.fn.materialPopinMassupdates.langs = {
		fr: {
			ValidateButton: 'Valider',
			CancelButton: 'Annuler',
			AddButton: 'Ajouter un champ',
			FieldColumn: 'Champ',
			ClearColumn: 'Vider',
			ValueColumn: 'Valeur',
			RemoveButton: 'Supprimer le champ'
		},
		en: {
			ValidateButton: 'Validate',
			CancelButton: 'Cancel',
			AddButton: 'Add field',
			FieldColumn: 'Field',
			ClearColumn: 'Empty',
			ValueColumn: 'Value',
			RemoveButton: 'Remove field'
		},
		de: {
			ValidateButton: 'Validieren',
			CancelButton: 'Abbrechen',
			AddButton: 'ein Field fügen',
			FieldColumn: 'Kriterium',
			ClearColumn: 'Leerer',
			ValueColumn: 'Wert',
			RemoveButton: 'das Field löschen'
		}
	};

})(window.jQuery, window.moment);